import { Card, Header } from "semantic-ui-react";

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Table from "../../../../ui/components/Table/Table";

import useUserPricesColumns from "../hooks/useUserPricesColumns";

import UserPricesActions from "./UserPricesActions";

export default function UserPrices({ user, organization }) {
	const { t } = useTranslation();

	const data = useMemo(() => Object.values(user.prices?.[organization.id] || {}), [organization.id, user.prices]);

	const columns = useUserPricesColumns({ user, organization });

	return (
		<>
			<Header as="h3">{t("defaultPricing", "Default pricing")}</Header>

			<Card fluid>
				<Card.Content>
					<Table data={data} columns={columns} footer={false} />
				</Card.Content>

				<Card.Content>
					<UserPricesActions user={user} organization={organization} />
				</Card.Content>
			</Card>
		</>
	);
}
